export default "__VITE_ASSET__DOQ01ofG__"